<template>
  <div class="hello">
    <h1>Pinnacle Order Entry tool coming soon!</h1>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld'
}
</script>

<style scoped>
h1 {
  color: #42b983;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>